import React, { useState } from "react";

import dayjs from "dayjs";

import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import DOMPurify from "dompurify";

import {
  InfoCard,
  CardItemContainer,
  CardHeader,
  ColumnDiv,
  TopBarActions,
  IconContainer,
} from "./styled";
import { CreateNewExperienceModal } from "../ExperienceModal";

const sanitizeHtml = (html) => {
  const safeHtml = DOMPurify.sanitize(html);

  return <div dangerouslySetInnerHTML={{ __html: safeHtml }} />;
};

export const ExperienceCard = ({
  experience,
  userData,
  getData,
  hideActions = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");

  const closeModal = () => {
    setModalOpen(false);
    setModalType("");
    getData();
  };

  const handleDeleteClick = async () => {
    setModalType("delete");
    setModalOpen(true);
  };

  const handleEditClick = async () => {
    setModalType("edit");
    setModalOpen(true);
  };

  return (
    <>
      <InfoCard>
        <CardItemContainer>
          <CardHeader>
            <BusinessCenterIcon sx={{ color: "#104467", fontSize: 40 }} />
            <ColumnDiv>
              <h3>{experience.role}</h3>
              <span>{experience.local}</span>
            </ColumnDiv>
          </CardHeader>
          {hideActions ? (
            <></>
          ) : (
            <TopBarActions>
              <IconContainer onClick={handleDeleteClick}>
                <DeleteIcon />
              </IconContainer>
              <IconContainer onClick={handleEditClick}>
                <EditIcon />
              </IconContainer>
            </TopBarActions>
          )}
        </CardItemContainer>
        <ColumnDiv>
          <span>
            {`${dayjs(experience.start_date).format("DD/MM/YYYY") || ""} - ${
              experience.end_date
                ? dayjs(experience.end_date).format("DD/MM/YYYY")
                : "Atual"
            }`}
          </span>
        </ColumnDiv>
        <CardItemContainer>
          <ColumnDiv>
            <h4>Habilidades e Ferramentas:</h4>
            <span
              style={{
                marginTop: "10px",
                paddingRight: "5px",
                textAlign: "justify",
              }}
            >
              {sanitizeHtml(experience.technologies)}
            </span>
          </ColumnDiv>
        </CardItemContainer>
      </InfoCard>
      <CreateNewExperienceModal
        open={modalOpen}
        onClose={closeModal}
        user={userData}
        type={modalType}
        experience={experience}
      />
    </>
  );
};
